import axios from '@/utils/api';
import vueCookie from 'vue-cookie';

export default {
  namespaced: true,

  state: {
    authToken: null,
    authStatus: false
  },

  getters: {
    getAuthToken (state) {
      return state.authToken
    },

    getAuthStatus (state) {
      return state.authStatus
    }
  },

  actions: {
    async login ({ commit }, { login, password }) {
      const authToken = `Basic ${btoa(login + ':' + password)}`
      
      const response = await axios.post('/login', {}, { 
        headers: {
          'Authorization': authToken,
        },
      })

      if (response.status === 200) {
        commit('setAuthToken', authToken)
        vueCookie.set('authToken', authToken)
        commit('setAuthStatus', true)
      } else {
        throw response.status
      }
    },

    initAuth ({ commit, getters }) {
      const token = vueCookie.get('authToken')
      if (token && !getters['getAuthStatus']) {
        commit('setAuthToken', token)
        commit('setAuthStatus', true)
      }
    },

    setAuthToken ({ commit }, token) {
      commit('setAuthToken', token)
    },

    setAuthStatus({ commit }, status) {
      commit('setAuthStatus', status)
    }
  },

  mutations: {
    setAuthToken(state, token) {
      state.authToken = token
    },

    setAuthStatus(state, status) {
      state.authStatus = status
    }
  }
}